import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { uploadFileS3Api as API } from '../Apis';
import { UploadFileS3Types } from '../Types';

export const UploadFileS3Docs: IDocs = {
  title: 'uploadFileS3',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.uploadFileS3',
};

const prepareCall = (stateRequestParameters: {
  category: keyof typeof UploadFileS3Types.CategoryUploadType;
  extension: string;
  file: string;
}) =>
  API.call.post({
    category:
      UploadFileS3Types.CategoryUploadType[stateRequestParameters.category],
    extension: stateRequestParameters.extension,
    file: stateRequestParameters.file,
  });

export const UploadFileS3Machine = GenericMachine(prepareCall, {
  docs: UploadFileS3Docs,
  definitions: API.definitions,
});
